<ion-header>
  <ion-toolbar>
    <ion-title>Aceptar los términos y condiciones</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-text-center">
  
  <div class="botones-container" *ngIf="configService.company_info.name.toLowerCase() !== 'gabriamigos'">
    <p>Hemos actualizado los condiciones del programa, te invitamos a leerlos aquí <a target="_blank" [href]="terms">Términos y condiciones</a>. </p>
    <p>Al hacer clic en el botón Aceptar que aparece a continuación, nos confirmas que estas de acuerdo con las condiciones del programa.</p>
  </div>

  <div class="botones-container" *ngIf="configService.company_info.name.toLowerCase() == 'gabriamigos'">
    <p>Hemos actualizado las condiciones del programa, te invitamos a leerlos aquí <a target="_blank" [href]="terms">Términos y condiciones</a>. </p>
    <p>Al aceptar los Términos y condiciones del programa nos confirmas que estás de acuerdo.</p>
  </div>


  <div class="botones-container">
    <ion-button (click)="accept()">Aceptar</ion-button>
    <ion-button (click)="cancel()">Cancelar</ion-button>
  </div>
</ion-content>

